// Shared helpers for rendering audit-log entries (Logboek).

export const ACTION_LABELS = {
  create: 'Aangemaakt',
  update: 'Gewijzigd',
  delete: 'Verwijderd',
  revert: 'Teruggedraaid',
};

// CSS modifier class per action (colors defined in AuditLog.css / AuditHistoryModal.css)
export const ACTION_CLASS = {
  create: 'create',
  update: 'update',
  delete: 'delete',
  revert: 'revert',
};

const SKIP_FIELDS = new Set(['id', 'created_at', 'updated_at']);

function toObj(v) {
  if (!v) return null;
  if (typeof v === 'string') {
    try { return JSON.parse(v); } catch { return null; }
  }
  return typeof v === 'object' ? v : null;
}

function formatValue(v) {
  if (v === null || v === undefined || v === '') return '—';
  if (typeof v === 'boolean') return v ? 'ja' : 'nee';
  if (typeof v === 'object') {
    try { return JSON.stringify(v); } catch { return String(v); }
  }
  return String(v);
}

const sameVal = (a, b) => formatValue(a) === formatValue(b);

// Returns an array of { field, from, to } for the fields that differ.
export function computeChanges(oldValues, newValues) {
  const oldObj = toObj(oldValues) || {};
  const newObj = toObj(newValues) || {};
  const keys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)]);
  const changes = [];
  for (const key of keys) {
    if (SKIP_FIELDS.has(key)) continue;
    const from = oldObj[key];
    const to = newObj[key];
    if (!sameVal(from, to)) {
      changes.push({ field: key, from, to });
    }
  }
  return changes;
}

// Field values for a create (skip meta fields, drop empties).
export function entrySummaryFields(values, max = 3) {
  const obj = toObj(values) || {};
  const out = [];
  for (const key of Object.keys(obj)) {
    if (SKIP_FIELDS.has(key)) continue;
    const val = obj[key];
    if (val === null || val === undefined || val === '') continue;
    out.push({ field: key, value: formatValue(val) });
    if (out.length >= max) break;
  }
  return out;
}

export { formatValue };

export function formatDateTime(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleString('nl-NL', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
    });
  } catch {
    return String(iso);
  }
}
